function Conditions() {
    return (


        <iframe src="https://drive.google.com/file/d/1bFH9_yt6glDRqIyVTigOU7tb2ix65KMy/preview" width="100%" height="500" allow="autoplay" title="Conditions générales"></iframe>

  )}

  export default Conditions;
